export const mainnet = {
  chainId: 1,
  name: 'Ethereum',
  currency: 'ETH',
  explorerUrl: 'https://etherscan.io',
  rpcUrl: 'https://cloudflare-eth.com'
}

export const sepolia = {
  chainId: 11155111,
  name: 'Sepolia',
  currency: 'ETH',
  explorerUrl: 'https://sepolia.etherscan.io',
  rpcUrl: 'https://rpc.sepolia.org'
}

export const arbitrum = {
  chainId: 42161,
  name: 'Arbitrum',
  currency: 'ETH',
  explorerUrl: 'https://arbiscan.io',
  rpcUrl: 'https://arb1.arbitrum.io/rpc'
}

export const arbitrumGoerli = {
  chainId: 421613,
  name: 'Arbitrum Goerli',
  currency: 'ETH',
  explorerUrl: 'https://goerli.arbiscan.io',
  rpcUrl: 'https://goerli-rollup.arbitrum.io/rpc'
}

export const avalanche = {
  chainId: 43114,
  name: 'Avalanche',
  currency: 'AVAX',
  explorerUrl: 'https://snowtrace.io',
  rpcUrl: 'https://api.avax.network/ext/bc/C/rpc'
}

export const bsc = {
  chainId: 56,
  name: 'Binance Smart Chain',
  currency: 'BNB',
  explorerUrl: 'https://bscscan.com',
  rpcUrl: 'https://rpc.ankr.com/bsc'
}

export const ink = {
  chainId: 57073,
  name: 'Ink',
  currency: 'ETH',
  explorerUrl: 'https://explorer.inkonchain.com',
  rpcUrl: 'https://rpc-gel.inkonchain.com'
}

export const inkSepolia = {
  chainId: 763373,
  name: 'Ink Sepolia',
  currency: 'ETH',
  explorerUrl: 'https://explorer-sepolia.inkonchain.com',
  rpcUrl: 'https://rpc-gel-sepolia.inkonchain.com'
}

export const optimism = {
  chainId: 10,
  name: 'Optimism',
  currency: 'ETH',
  explorerUrl: 'https://optimistic.etherscan.io',
  rpcUrl: 'https://mainnet.optimism.io'
}

export const optimismGoerli = {
  chainId: 420,
  name: 'Optimism Goerli',
  currency: 'ETH',
  explorerUrl: 'https://goerli-optimism.etherscan.io',
  rpcUrl: 'https://goerli.optimism.io'
}

export const polygon = {
  chainId: 137,
  name: 'Polygon',
  currency: 'MATIC',
  explorerUrl: 'https://polygonscan.com',
  rpcUrl: 'https://polygon-rpc.com'
}

export const polygonMumbai = {
  chainId: 80001,
  name: 'Polygon Mumbai',
  currency: 'MATIC',
  explorerUrl: 'https://mumbai.polygonscan.com',
  rpcUrl: 'https://rpc.ankr.com/polygon_mumbai'
}

export const gnosis = {
  chainId: 100,
  name: 'Gnosis',
  currency: 'xDAI',
  explorerUrl: 'https://gnosis.blockscout.com',
  rpcUrl: 'https://rpc.gnosischain.com'
}

export const zkSync = {
  chainId: 324,
  name: 'ZkSync',
  currency: 'ETH',
  explorerUrl: 'https://explorer.zksync.io',
  rpcUrl: 'https://mainnet.era.zksync.io'
}

export const zora = {
  chainId: 7777777,
  name: 'Zora',
  currency: 'ETH',
  explorerUrl: 'https://explorer.zora.energy',
  rpcUrl: 'https://rpc.zora.energy'
}

export const celo = {
  chainId: 42220,
  name: 'Celo',
  currency: 'CELO',
  explorerUrl: 'https://explorer.celo.org/mainnet',
  rpcUrl: 'https://forno.celo.org'
}

export const base = {
  chainId: 8453,
  name: 'Base',
  currency: 'BASE',
  explorerUrl: 'https://basescan.org',
  rpcUrl: 'https://mainnet.base.org'
}

export const aurora = {
  chainId: 1313161554,
  name: 'Aurora',
  currency: 'ETH',
  explorerUrl: 'https://explorer.aurora.dev',
  rpcUrl: 'https://mainnet.aurora.dev'
}

export const ronin = {
  chainId: 2020,
  name: 'Ronin',
  currency: 'RON',
  explorerUrl: 'https://app.roninchain.com',
  rpcUrl: 'https://api.roninchain.com/rpc'
}

export const saigon = {
  chainId: 2021,
  name: 'Saigon Testnet',
  currency: 'RON',
  explorerUrl: 'https://saigon-explorer.roninchain.com',
  rpcUrl: 'https://saigon-testnet.roninchain.com/rpc'
}
